module.exports = function getResource (label, vars = []) {
    let resources = {
        signOutInfoModalTitle: 'Confirmation',
        signOutInfoModalMessage: 'Les articles suivants seront supprimés : Tout le stock immatériel, sauf les cartes cadeau. Souhaitez-vous vraiment continuer?',
        signOutInfoModalButtonText: 'Continuer'
    };
    return resources[label];
};
